import { untrack } from "solid-js";
export const wireSignal = (signal) => [
    new Proxy(() => signal[0](), {
        get: (_, key) => signal[0][key],
    }),
    new Proxy((setStateAction) => signal[1](setStateAction), {
        get: (_, key) => signal[1][key],
    }),
];
export const signalExtender = (signal) => ({
    extend(extensions, createBaseSetter) {
        if (createBaseSetter)
            signal[1] = (() => {
                const [extendedGet, extendedSet] = extensions(wireSignal(signal));
                return Object.assign(createBaseSetter([
                    Object.assign(signal[0], extendedGet),
                    Object.assign(signal[1], extendedSet),
                ]), signal[1]);
            })();
        else
            extensions(wireSignal(signal)).forEach((value, i) => {
                Object.assign(signal[i], value);
            });
        // Must use mutation instead of creating new array to keep reference for wireSignal
        signal[1] = untrackDeep(signal[1]);
        return signal;
    },
});
const untrackDeep = (target) => {
    return new Proxy(target, {
        apply(target, _this, args) {
            if (typeof target !== "function")
                throw new Error(`Target is not callable, called with ${args.join(", ")}`);
            return untrack(() => target(...args));
        },
        get(target, p) {
            if (!(p in target))
                throw new Error(`Property ${
                // Symbol casting
                String(p)} does not exist in Target`);
            return untrackDeep(target[p]);
        },
    });
};
export const getNativeExtensions = (makeCopy, setState, mutators) => Object.fromEntries(mutators.map((method) => [
    method,
    (...args) => {
        const s = makeCopy();
        // @ts-expect-error
        const res = s[method](...args);
        setState(s);
        return res;
    },
]));
